export default __webpack_public_path__ + "static/media/ic_exit.c69c93c1.svg";